<template lang="pug">
    div.notification-page
        select-filter-control.notification-page__filter(v-model="filter" :options="filterOptions")
        notifications-control.notification-page__notifications(:value="notifications")
</template>

<script>
import notificationsService from '../services/notifications-service'

export default {
    name: 'notification-page',
    data() {
        return {
            notifications: [],
            filter: '',
        }
    },
    computed: {
        filterOptions() {
            return [
                { name: 'All', value: '', iconId: 'filter-all' },
                { name: 'Interactions', value: 'interaction', iconId: 'filter-interactions' },
                { name: 'Liked', value: 'like', iconId: 'filter-likes' },
                { name: 'New Followers', value: 'new-follower', iconId: 'filter-followers' },
                { name: 'Tips', value: 'tip', iconId: 'filter-tips' },
                { name: 'Purchases', value: 'purchase', iconId: 'filter-purchases' },
            ]
        },
    },
    watch: {
        filter() {
            this.load()
        },
    },
    methods: {
        load() {
            notificationsService.list({
                type: this.filter,
            }).then(({ data }) => {
                this.notifications = data.data
            })
        },
    },
    created() {
        this.load()
    },
}
</script>
